/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface VisiteFormateurSearch
 */
export interface VisiteFormateurSearch {
    /**
     * 
     * @type {number}
     * @memberof VisiteFormateurSearch
     */
    idVisite?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisiteFormateurSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof VisiteFormateurSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteFormateurSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VisiteFormateurSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof VisiteFormateurSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof VisiteFormateurSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the VisiteFormateurSearch interface.
 */
export function instanceOfVisiteFormateurSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisiteFormateurSearchFromJSON(json: any): VisiteFormateurSearch {
    return VisiteFormateurSearchFromJSONTyped(json, false);
}

export function VisiteFormateurSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisiteFormateurSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idVisite': !exists(json, 'idVisite') ? undefined : json['idVisite'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function VisiteFormateurSearchToJSON(value?: VisiteFormateurSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idVisite': value.idVisite,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

